import { Slide, Zoom } from "react-awesome-reveal";
import { IoLocationOutline } from "react-icons/io5";
import { MdAlternateEmail } from "react-icons/md";

const ProfileSection = () => {
  return (
    <section>
      {/* <IntroSection/> */}
      {/* <a name="intro"></a> */}
      <div className="lg:flex flex-col">
        <div className="profile-section-wrapper landscape:grid landscape:grid-cols-2 lg:grid grid-cols-2 gap-x-[2rem] pb-[3rem] lg:pb-[5rem]">
          <Zoom triggerOnce={true} fraction={0.2}>
            <div className="img-wrapper order-2">
              <picture>
                <img
                  src="emuobo-profile1.webp"
                  className="profile-image object-cover w-full h-[19rem] md:h-[32rem] max-h-[27rem] md:max-h-[32rem] landscape:h-[90vh] rounded border border-[#e5e5e5]"
                  alt="emmuobopleasure"
                />
              </picture>
            </div>
          </Zoom>
          <div className="profile-contact mt-6 grid grid-cols-2 gap-[2rem] order-1 md:items-end">
            <Slide triggerOnce={true} fraction={0.6}>
              <div className="profile-contact">
                <div className="contact-icon hidden landscape:flex lg:flex justify-center">
                  <MdAlternateEmail
                    size="7rem"
                    className="mail-icon text-gray-300 mb-[2rem] animate-bounce"
                  />
                </div>
                <div className="divider-line border-b-[.0625rem] border-[#e5e5e5] mb-[2rem]"></div>
                <div className="profile-contact text-[#4deaa7] mb-1 text-[0.8625rem]">
                  CONTACT
                </div>
                <div className="profile-email leading-[1.625rem] break-words md:break-normal">
                  emuobopleasure@outlook.com
                </div>
              </div>
            </Slide>
            <Slide direction="right" triggerOnce={true} fraction={0.6}>
              <div className="profile-location">
                <div className="location-icon hidden landscape:flex lg:flex justify-center">
                  <IoLocationOutline
                    size="7rem"
                    className="location-icon text-gray-300 mb-[2rem] animate-bounce "
                  />
                  {/* <IoLocationOutline/> */}
                </div>
                <div className="divider-line border-b-[.0625rem] border-[#e5e5e5] mb-[2rem]"></div>
                <div className="profile-location text-[#4deaa7] mb-1 text-[0.8625rem]">
                  LOCATION
                </div>
                <div className="profile-email leading-[1.625rem] break-words md:break-normal">
                  Lagos, Nigeria (Remote)
                </div>
              </div>
            </Slide>
          </div>
        </div>
        {/* <Fade direction="up" triggerOnce={true}>
          <div>
            <p className="sub-headline mb-8 text-[4.5vw] leading-[135%] md:text-[1.5rem] md:leading-[2.375rem] lg:text-[2.525rem] lg:leading-[3.25rem]">
              I work with founders and product teams to design and build frontend systems that users understand, trust, and keep using.
            </p>
          </div>
        </Fade> */}
        {/* <Fade direction="up" triggerOnce={true}>
          <h2
            aria-label="projects-section"
            className="my-projects pt-[2rem] lg:pt-[8rem] mb-[4rem] text-[2.75rem] tracking-[-0.25rem] leading-[3.375rem] md:text-[3.125rem] md:leading-[3.75rem] lg:mb-[5rem] lg:leading-[4.375rem] lg:text-[4.375rem] xl:mb-[7rem] xl:leading-[5rem]"
          >
            About me
          </h2>
        </Fade>
        <div className="work-resume pb-[2rem] lg:pb-[8rem] text-[6vw] leading-[135%] md:text-[1.75rem] md:leading-[2.375rem] lg:text-[2.525rem] lg:leading-[3.25rem]">
          <Fade direction="up" triggerOnce={true}>
            <div className="work-text">
              <p>
                I’m a frontend engineer who works with founders and product teams to turn complex ideas into interfaces users actually understand and trust.
              </p>
              <br />
              <p>
                Most frontend problems I solve aren’t about frameworks or components. They’re about clarity:
              </p>
              <br />
              <ul>
                <li>
                  • Flows that confuse users.
                </li>
                <li>
                  • UI decisions that don’t scale.
                </li>
                <li>
                  • Features that “work” but hurt adoption.
                </li>
              </ul>
              <br />
              <p>
                On recent projects, I:
              </p>
              <br />
              <ul className="gap-2">
                <li>
                  • Built a scalable frontend for a growing business, including chat-to-order flows that reduced purchase friction.
                </li>
                <li>
                  • Delivered an investor-ready startup website by quickly adapting to a new framework under tight deadlines.
                </li>
              </ul>
              <br />
              <p>
                My focus is building frontend systems that balance performance, maintainability, and real business goals, not just visual polish.
              </p>
              <br />
              <p>
                If you’re building a product and want frontend that holds up as the product grows, let’s talk.
              </p>
            </div>
          </Fade>
          <Resume />
        </div> */}
        {/* <TechStack /> */}
      </div >
    </section >
  );
};

export default ProfileSection;
